export const projectData = [
  {
    id: 'arapp',
    title: 'App with integrated Augmented reality.',
    content: [
      'I am developing an app with integrated augmented reality. Its users can utilise the function to learn more about the points of interest (POI) in their chosen locations. Upon arrival at the POI, the users have an opportunity to scan a QR code provided in the app. After scanning, the app will display 3D or 2D objects in the users´ device cameras. These objects track the QR code´s position on the screen.',
      'Additionally, I am also working on a GPS tracking function. This function will allow the users to calculate their distance from their chosen POIs. Once in a close proximity of around 5-10 metres from the chosen POI, the app will display the objects as in real life around the user. (APP currently works on phones)',
    ],
    links: [
      {
        href: 'https://github.com/FilipBrady/bigwayarweb',
        text: 'GitHub',
      },
      {
        href: 'http://app.bigway.sk/',
        text: 'Web Link',
      },
    ],
    interactiveContent: {
      type: 'iframe',
      src: 'http://app.bigway.sk/',
      title: 'ArApp',
      style: {
        maxWidth: '580px',
      },
    },
  },
  {
    id: 'subkontrakt',
    title: 'Manager of an advertising website',
    content: [
      'I am a manager of an advertising website and my duties include: managing and working with Google Ads, Meta Ads, and Mailchimp, creating and posting content on social media (Facebook, Instagram, LinkedIn), devising innovating ideas for the site, manual site testing, customer service and problem-solving, directing the site maintenance and communicating with partner companies.',
    ],
    links: [
      {
        href: 'https://subkontrakt.sk/',
        text: 'Web Link',
      },
    ],
    interactiveContent: {
      type: 'iframe',
      src: 'https://www.subkontrakt.sk',
      title: 'Subkontrakt.sk',
    },
  },
  {
    id: 'metrostav',
    title: 'Presentation website for a construction company',
    content: [
      'This is a presentation website for a construction company in Slovakia, created using WordPress and the Oxygen Builder. The design was provided by the client.',
      'The website is built with a focus on custom post types (e.g., https://metrostav.bigway.sk/projekt/river-park/), taxonomies, a blog, and a contact page with an interactive map.',
    ],
    links: [
      {
        href: 'https://metrostav.bigway.sk/',
        text: 'Web Link',
      },
    ],
    interactiveContent: {
      type: 'iframe',
      src: 'https://metrostav.bigway.sk/',
      title: 'Metrostav',
    },
  },
  {
    id: 'ZZGK',
    title:
      'Presentation website for a Employers´ Association of Geodesy and Cartography',
    content: [
      'This is a presentation website for the Employers´ Association of Geodesy and Cartography in Slovakia, created using WordPress and Oxygen Builder. The website emphasizes design and simplicity.',
    ],
    links: [
      {
        href: 'https://zzgk.bigway.sk/',
        text: 'Web Link',
      },
    ],
    interactiveContent: {
      type: 'iframe',
      src: 'https://zzgk.bigway.sk/',
      title: 'ZZGK',
    },
  },
  {
    id: 'Orex',
    title: 'Presentation website for a client',
    content: [
      'This was one of my first full website projects in Wordpress for a client. The website is made through Wordpress with the use of Oxygen builder.',
      'This website creation was challenging, as it required me to further my skills and learn how to create custom post types and taxonomies and how to display them on frontend. After quite a few struggles, I figured it out and the results can be seen here.',
    ],
    links: [
      {
        href: 'https://orex.bigway.sk/',
        text: 'Web Link',
      },
    ],
    interactiveContent: {
      type: 'iframe',
      src: 'https://orex.bigway.sk/',
      title: 'Orex',
    },
  },

  {
    id: 'orobactos',
    title: 'Presentation website for a client',
    content: [
      'This is a presentation website for a client. Website is made through Wordpress with the use of Oxygen builder. The design was provided by the client.',
      'The structure of the website was simple. Few static subpages and a page for a blog.',
    ],
    links: [
      {
        href: 'https://orobactos.sk/',
        text: 'Web Link',
      },
    ],
    interactiveContent: {
      type: 'iframe',
      src: 'https://orobactos.sk/',
      title: 'Orobactos',
    },
  },

  {
    id: 'todoapp',
    title: 'To do app using MockApi and Next.js',
    content: [
      'This app is made in NextJS with the help of MockApi. This is my second Next.js project and my first one using an API and Axios. The user can add a Todo List with Todo Items. Todo Items contain an item title, description, and a deadline. The user can set the list´s priorities and change the list title, as well as the item title and description.',
    ],
    links: [
      {
        href: 'https://github.com/FilipBrady/mytodoapp',
        text: 'GitHub',
      },
      {
        href: 'https://mytodoapp-pearl.vercel.app/',
        text: 'Web Link',
      },
    ],
    interactiveContent: {
      type: 'iframe',
      src: 'https://mytodoapp-pearl.vercel.app/',
      title: 'MyTodoApp',
    },
  },
  {
    id: 'onlinelaunch',
    title: 'Mobile version of a website for my client',
    content: [
      'I was contracted by a client to develop a mobile version of their website. The client provided the design mockups and I was responsible for implementing all the necessary animations and transitions.',
    ],
    links: [
      {
        href: 'https://github.com/FilipBrady/onlinelaunch',
        text: 'GitHub',
      },
      {
        href: 'https://onlinelaunch-eu1u.vercel.app',
        text: 'Web Link',
      },
    ],
    interactiveContent: {
      type: 'iframe',
      src: 'https://onlinelaunch-eu1u.vercel.app/',
      title: 'onlinelaunch',
    },
  },
  {
    id: 'calculator',
    title: 'Simple calculator app',
    content: [
      'This is a simple calculator app. C deletes all content and DEL only the last digit.',
      'The first selected number displays above a new number. Calculator uses useReducer to do all the mathematical operations.',
      'Hitting = provides a user with a result. The user may then either click C to delete the result or continue in operations by clicking for example +.',
    ],
    links: [
      {
        href: 'https://github.com/FilipBrady/calculator',
        text: 'GitHub',
      },
    ],
    interactiveContent: {
      type: 'component',
      name: 'Calculator',
    },
  },
];
